import { withFieldGroup } from "components/Forms/AppForm";

const createMemberFieldsDefaults = {
  name: "",
  email: "",
};

const CreateMemberFields = withFieldGroup({
  defaultValues: createMemberFieldsDefaults,
  render: function Render({ group }) {
    return (
      <>
        <group.AppField name="name">
          {(field) => <field.TextInput label="Full Name" required />}
        </group.AppField>
        <group.AppField name="email">
          {(field) => <field.TextInput label="Email" required />}
        </group.AppField>
      </>
    );
  },
});

export default CreateMemberFields;
